module.exports = "<hot-table [rowHeaderWidth]=\"350\" [manualColumnResize]=\"true\" [colWidths]=\"300\" [autoColumnSize]=\"true\" [startRows]=\"35\" [minSpareRows]=\"0\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" [cell]=\"cells\" hotId=\"Metadata\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/metadata/metadata.component.html
// module id = ./src/app/metadata/metadata.component.html
// module chunks = main